import * as React from 'react'

import { observer } from 'mobx-react'

const ExplotableList = ({ children }: React.PropsWithChildren<{}>) => <ul>{children}</ul>

export default observer(ExplotableList)
